import { render } from "./Flag.vue?vue&type=template&id=60ee0d6a&scoped=true"
import script from "./Flag.vue?vue&type=script&lang=js"
export * from "./Flag.vue?vue&type=script&lang=js"

import "./Flag.vue?vue&type=style&index=0&id=60ee0d6a&lang=scss&scoped=true"

import exportComponent from "/Users/klaus/Projects/sfdc-happy-soup/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ee0d6a"]])

export default __exports__